import React from 'react';
import Input from "../UI/Input";
import Button from "../UI/Button";

const Form = ({onSubmit, error}) => {

    const formRef = React.useRef();

    const handleSubmit = (e) => {
        e.preventDefault();
        let email = formRef.current.email.value;
        let password = formRef.current.password.value;

        let fields = {
            email,
            password
        }

        onSubmit && onSubmit(fields);
    }

    return (
        <form className="p-4 bg-ea_green_from rounded-lg mt-4 text-white " onSubmit={handleSubmit} ref={formRef}>
            <Input label="Email"
                   type="email"
                   name="email"
                   placeholder="Inserisci la tua email"/>
            <Input label="Password"
                   type="password"
                   name="password"
                   placeholder="Inserisci la tua password"/>
            {error && error !== "" &&
            <div className="text-red-400 font-bold mt-4">{error}</div>
            }
            <Button type='submit' className="mt-4 w-full text-black ">Accedi</Button>
        </form>
    );
};

export default Form;
